import React, { useMemo, useState } from "react";
import {
    Search,
    RotateCcw,
    Eye,
    Phone,
    Mail,
    ChevronLeft,
    ChevronRight,
} from "lucide-react";

import "../styles/Customers.css";

const customerData = [
    {
        id: "CUS00089",
        name: "Kumar",
        phone: "9876543210",
        email: "kumar@gmail.com",
        location: "Erode",
        totalQuotes: 5,
        lastQuote: "10 Oct 2026",
        status: "ACTIVE",
    },
    {
        id: "CUS00088",
        name: "Rajesh",
        phone: "9876543211",
        email: "rajesh@gmail.com",
        location: "Coimbatore",
        totalQuotes: 3,
        lastQuote: "12 Oct 2026",
        status: "ACTIVE",
    },
    {
        id: "CUS00087",
        name: "Prakash",
        phone: "9876543212",
        email: "prakash@gmail.com",
        location: "Chennai",
        totalQuotes: 7,
        lastQuote: "14 Oct 2026",
        status: "ACTIVE",
    },
    {
        id: "CUS00086",
        name: "Suresh",
        phone: "9876543213",
        email: "suresh@gmail.com",
        location: "Salem",
        totalQuotes: 2,
        lastQuote: "15 Oct 2026",
        status: "ACTIVE",
    },
    {
        id: "CUS00085",
        name: "Arun",
        phone: "9876543214",
        email: "arun@gmail.com",
        location: "Tiruppur",
        totalQuotes: 4,
        lastQuote: "18 Oct 2026",
        status: "ACTIVE",
    },
    {
        id: "CUS00084",
        name: "Mohan",
        phone: "9876543215",
        email: "mohan@gmail.com",
        location: "Erode",
        totalQuotes: 1,
        lastQuote: "20 Oct 2026",
        status: "INACTIVE",
    },
    {
        id: "CUS00083",
        name: "Vijay",
        phone: "9876543216",
        email: "vijay@gmail.com",
        location: "Bangalore",
        totalQuotes: 6,
        lastQuote: "21 Oct 2026",
        status: "ACTIVE",
    },
    {
        id: "CUS00082",
        name: "Senthil",
        phone: "9876543217",
        email: "senthil@gmail.com",
        location: "Chennai",
        totalQuotes: 3,
        lastQuote: "23 Oct 2026",
        status: "ACTIVE",
    },
    {
        id: "CUS00081",
        name: "Manoj",
        phone: "9876543218",
        email: "manoj@gmail.com",
        location: "Madurai",
        totalQuotes: 2,
        lastQuote: "25 Oct 2026",
        status: "ACTIVE",
    },
    {
        id: "CUS00080",
        name: "Dinesh",
        phone: "9876543219",
        email: "dinesh@gmail.com",
        location: "Salem",
        totalQuotes: 4,
        lastQuote: "26 Oct 2026",
        status: "ACTIVE",
    },
];

const getStatusClass = (status) => {
    return status === "ACTIVE"
        ? "customer-status-active"
        : "customer-status-inactive";
};

export default function Customers() {
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("ALL");
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const filteredCustomers = useMemo(() => {
        return customerData.filter((customer) => {
            const value = search
                .toLowerCase()
                .trim();

            const matchesSearch =
                !value ||
                customer.id
                    .toLowerCase()
                    .includes(value) ||
                customer.name
                    .toLowerCase()
                    .includes(value) ||
                customer.phone.includes(value) ||
                customer.email
                    .toLowerCase()
                    .includes(value) ||
                customer.location
                    .toLowerCase()
                    .includes(value);

            const matchesStatus =
                status === "ALL" ||
                customer.status === status;

            return matchesSearch && matchesStatus;
        });
    }, [search, status]);

    const totalPages = Math.max(
        1,
        Math.ceil(
            filteredCustomers.length /
                rowsPerPage
        )
    );

    const currentPage = Math.min(
        page,
        totalPages
    );

    const paginatedCustomers =
        filteredCustomers.slice(
            (currentPage - 1) * rowsPerPage,
            currentPage * rowsPerPage
        );

    const clearFilters = () => {
        setSearch("");
        setStatus("ALL");
        setPage(1);
    };

    return (
        <div className="customers-page">

            {/* Header */}
            <div className="customers-page-header">

                <div>
                    <h1>Customers</h1>

                    <p>
                        Manage customers and their quote history.
                    </p>
                </div>

                <div className="customers-count">

                    <strong>
                        {filteredCustomers.length}
                    </strong>

                    <span>
                        Customers
                    </span>

                </div>

            </div>


            {/* Filters */}
            <div className="customers-filter-card">

                <div className="customer-search">

                    <Search size={17} />

                    <input
                        type="text"
                        placeholder="Search name, mobile, email or location..."
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value);
                            setPage(1);
                        }}
                    />

                </div>


                <div className="customer-status-filter">

                    <select
                        value={status}
                        onChange={(e) => {
                            setStatus(
                                e.target.value
                            );
                            setPage(1);
                        }}
                    >

                        <option value="ALL">
                            All Status
                        </option>

                        <option value="ACTIVE">
                            Active
                        </option>

                        <option value="INACTIVE">
                            Inactive
                        </option>

                    </select>

                </div>


                <button
                    className="customer-clear-btn"
                    onClick={clearFilters}
                >
                    <RotateCcw size={15} />

                    <span>
                        Clear
                    </span>
                </button>

            </div>


            {/* Table */}
            <div className="customers-table-card">

                <div className="customers-table-header">

                    <div>
                        <h3>
                            Customer List
                        </h3>

                        <p>
                            Showing{" "}
                            {paginatedCustomers.length}{" "}
                            of{" "}
                            {filteredCustomers.length}
                            {" "}customers
                        </p>
                    </div>

                </div>


                {/* Desktop */}
                <div className="customers-table-wrapper">

                    <table className="customers-table">

                        <thead>
                            <tr>

                                <th>CUSTOMER</th>

                                <th>CONTACT</th>

                                <th>LOCATION</th>

                                <th>TOTAL QUOTES</th>

                                <th>LAST QUOTE</th>

                                <th>STATUS</th>

                                <th>ACTION</th>

                            </tr>
                        </thead>

                        <tbody>

                            {paginatedCustomers.length > 0 ? (
                                paginatedCustomers.map(
                                    (customer) => (

                                        <tr
                                            key={
                                                customer.id
                                            }
                                        >

                                            {/* Customer */}
                                            <td>

                                                <div className="customer-main">

                                                    <div className="customer-avatar-large">
                                                        {customer.name
                                                            .charAt(
                                                                0
                                                            )
                                                            .toUpperCase()}
                                                    </div>

                                                    <div className="customer-main-info">

                                                        <strong>
                                                            {
                                                                customer.name
                                                            }
                                                        </strong>

                                                        <span>
                                                            {
                                                                customer.id
                                                            }
                                                        </span>

                                                    </div>

                                                </div>

                                            </td>


                                            {/* Contact */}
                                            <td>

                                                <div className="customer-contact">

                                                    <div>
                                                        <Phone
                                                            size={
                                                                12
                                                            }
                                                        />

                                                        {
                                                            customer.phone
                                                        }
                                                    </div>

                                                    <div>
                                                        <Mail
                                                            size={
                                                                12
                                                            }
                                                        />

                                                        {
                                                            customer.email
                                                        }
                                                    </div>

                                                </div>

                                            </td>


                                            {/* Location */}
                                            <td>

                                                <span className="customer-location">
                                                    {
                                                        customer.location
                                                    }
                                                </span>

                                            </td>


                                            {/* Quotes */}
                                            <td>

                                                <span className="quote-count-badge">
                                                    {
                                                        customer.totalQuotes
                                                    }
                                                </span>

                                            </td>


                                            {/* Last quote */}
                                            <td>

                                                <span className="last-quote">
                                                    {
                                                        customer.lastQuote
                                                    }
                                                </span>

                                            </td>


                                            {/* Status */}
                                            <td>

                                                <span
                                                    className={`customer-status ${getStatusClass(
                                                        customer.status
                                                    )}`}
                                                >
                                                    {
                                                        customer.status
                                                    }
                                                </span>

                                            </td>


                                            {/* Action */}
                                            <td>

                                                <button
                                                    className="customer-view-btn"
                                                    title="View Customer"
                                                >
                                                    <Eye
                                                        size={
                                                            16
                                                        }
                                                    />
                                                </button>

                                            </td>

                                        </tr>

                                    )
                                )
                            ) : (
                                <tr>

                                    <td
                                        colSpan="7"
                                        className="no-customers"
                                    >
                                        No customers found
                                    </td>

                                </tr>
                            )}

                        </tbody>

                    </table>

                </div>


                {/* Mobile */}
                <div className="customers-mobile-list">

                    {paginatedCustomers.length > 0 ? (
                        paginatedCustomers.map(
                            (customer) => (

                                <div
                                    className="customer-mobile-card"
                                    key={
                                        customer.id
                                    }
                                >

                                    <div className="customer-mobile-top">

                                        <div className="customer-main">

                                            <div className="customer-avatar-large">
                                                {customer.name
                                                    .charAt(
                                                        0
                                                    )
                                                    .toUpperCase()}
                                            </div>

                                            <div className="customer-main-info">

                                                <strong>
                                                    {
                                                        customer.name
                                                    }
                                                </strong>

                                                <span>
                                                    {
                                                        customer.id
                                                    }
                                                </span>

                                            </div>

                                        </div>

                                        <span
                                            className={`customer-status ${getStatusClass(
                                                customer.status
                                            )}`}
                                        >
                                            {
                                                customer.status
                                            }
                                        </span>

                                    </div>


                                    <div className="customer-mobile-contact">

                                        <div>
                                            <Phone
                                                size={
                                                    13
                                                }
                                            />

                                            {
                                                customer.phone
                                            }
                                        </div>

                                        <div>
                                            <Mail
                                                size={
                                                    13
                                                }
                                            />

                                            {
                                                customer.email
                                            }
                                        </div>

                                    </div>


                                    <div className="customer-mobile-details">

                                        <div>
                                            <small>
                                                Location
                                            </small>

                                            <strong>
                                                {
                                                    customer.location
                                                }
                                            </strong>
                                        </div>

                                        <div>
                                            <small>
                                                Quotes
                                            </small>

                                            <strong>
                                                {
                                                    customer.totalQuotes
                                                }
                                            </strong>
                                        </div>

                                        <div>
                                            <small>
                                                Last Quote
                                            </small>

                                            <strong>
                                                {
                                                    customer.lastQuote
                                                }
                                            </strong>
                                        </div>

                                    </div>


                                    <button className="customer-mobile-view">

                                        <Eye
                                            size={
                                                15
                                            }
                                        />

                                        View Customer

                                    </button>

                                </div>

                            )
                        )
                    ) : (
                        <div className="mobile-no-customers">
                            No customers found
                        </div>
                    )}

                </div>


                {/* Pagination */}
                <div className="customers-pagination">

                    <div className="customers-pagination-info">
                        Page {currentPage} of{" "}
                        {totalPages}
                    </div>


                    <div className="customers-pagination-controls">

                        <select
                            value={rowsPerPage}
                            onChange={(e) => {
                                setRowsPerPage(
                                    Number(
                                        e.target
                                            .value
                                    )
                                );

                                setPage(1);
                            }}
                        >
                            <option value="5">
                                5 / page
                            </option>

                            <option value="10">
                                10 / page
                            </option>

                            <option value="20">
                                20 / page
                            </option>
                        </select>


                        <button
                            disabled={
                                currentPage ===
                                1
                            }
                            onClick={() =>
                                setPage(
                                    (p) =>
                                        Math.max(
                                            1,
                                            p - 1
                                        )
                                )
                            }
                        >
                            <ChevronLeft
                                size={16}
                            />
                        </button>


                        <span>
                            {currentPage}
                        </span>


                        <button
                            disabled={
                                currentPage ===
                                totalPages
                            }
                            onClick={() =>
                                setPage(
                                    (p) =>
                                        Math.min(
                                            totalPages,
                                            p + 1
                                        )
                                )
                            }
                        >
                            <ChevronRight
                                size={16}
                            />
                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
}